import { PlannedCard } from './_PlannedCard';

export function CommercePartnersStub() {
  return (
    <PlannedCard
      title="Partners"
      blurb="Retailers, vendors, brokers, 3PLs. Tiered by importance (A / B / C). Contact info, order history summary, channels they use."
    />
  );
}
